import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSidemenuLeftOpen(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M13 15C13 15.2022 13.1218 15.3846 13.3087 15.462C13.4955 15.5393 13.7106 15.4966 13.8536 15.3536L16.8536 12.3536C17.0488 12.1583 17.0488 11.8417 16.8536 11.6465L13.8536 8.64646C13.7106 8.50346 13.4955 8.46069 13.3087 8.53808C13.1218 8.61547 13 8.79779 13 9.00002V15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21L5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19584 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5L21 19ZM8 5L5 5L5 19H8L8 5ZM10 19L19 19L19 5L10 5L10 19Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
